import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Household } from '@/types'

type ViewMode = 'individual' | 'household'

interface ViewModeState {
  viewMode: ViewMode
  household: Household | null
  isLoadingHousehold: boolean
  setViewMode: (mode: ViewMode) => void
  setHousehold: (household: Household | null) => void
  setIsLoadingHousehold: (loading: boolean) => void
  hasHousehold: () => boolean
}

export const useViewModeStore = create<ViewModeState>()(
  persist(
    (set, get) => ({
      viewMode: 'individual',
      household: null,
      isLoadingHousehold: false,
      setViewMode: (viewMode: ViewMode) => set({ viewMode }),
      setHousehold: (household: Household | null) => set({ household }),
      setIsLoadingHousehold: (isLoadingHousehold: boolean) => set({ isLoadingHousehold }),
      hasHousehold: () => !!get().household,
    }),
    {
      name: 'view-mode-storage',
      partialize: (state) => ({ viewMode: state.viewMode }),
      onRehydrateStorage: () => (state) => {
        console.log('[ViewModeStore] Rehydrated with viewMode:', state?.viewMode)
      },
    }
  )
)
